import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import FeedMessageControls from './FeedMessageControls';
import MessageList from './MessageList';

export function FeedMessagesComponent(props) {
  const {
    messages,
    title,
    type,
  } = props;
  return (
    <div className="message" style={{ marginBottom: '10px' }}>
      <h1
        className="heading heading--1 messages__heading"
        style={{ display: 'flex', justifyContent: 'space-between' }}
      >
        {title}
        {type !== 'feedMessages' && (
          <FeedMessageControls />
        )}
      </h1>
      <MessageList messages={messages} type={type} />
    </div>
  );
}

FeedMessagesComponent.propTypes = {
  messages: PropTypes.arrayOf(PropTypes.shape({})),
  title: PropTypes.string.isRequired,
  type: PropTypes.string,
};

FeedMessagesComponent.defaultProps = {
  messages: [],
  type: undefined,
};

const mapStateToProps = ({ messages }, { type }) => ({ messages: messages[type] });

export default connect(mapStateToProps)(FeedMessagesComponent);